<template>
    <!-- TOP HEADER -->
    <section class="mainHeader">
        <div class="container-fluid">
            <div class="row" id="topHeader">

              <div class="col-md-7 col-sm-9 align-self-center" style="background-color: #FEC93C" id="topHeaderText">
                <div class="d-flex align-self-center" id="topHeaderParagraph">
                <p><span style="color:white">WE FIND JOY IN EVERY<br> SMILE OF THE </span>
                    <span style="color:#2f437a">CHILDREN</span><br> <span style="color:white">WE HAVE HELPED</span></p>
                </div>   
                </div>

              <div class="col-md-5 col-sm-3" style="background-color: #FEC93C">
                <div class="container-fluid align-self-end imgId">
                    <img src="@/assets/about-us/airplaneKid.png" class="img-fluid align-self-center " alt="Kid with Paper Airplane"> 
                </div>
              </div>
            </div>
        </div>
        </section>
    
        <!-- TRI-COLOR BANNER -->
        <section class="tricolorBanner">
            <div class="container-fluid">
                <div class="row" style="background-color: #FFFFFF" id="whiterow">
                    <p><span style="color:#FFFFFF">white</span></p>
                </div>
                <div class="row align-items-center">
                    <div class="col-md-4 col-sm-4" style="background-color: #FEC93C">
                        <p><span style="color:#FEC93C">yellow</span></p>
                    </div>
                    <div class="col-md-4 col-sm-4" style="background-color:#953541">
                        <p><span style="color:#953541">red</span></p>
                    </div>
                    <div class="col-md-4 col-sm-4" style="background-color:#2F437A">
                        <p><span style="color:#2F437A">blue</span></p>
                    </div>
                </div>
            </div>
        </section>
    
    <!-- ABOUT US TEXT -->
    <section class="aboutUsMain">
        <div class="container-fluid"> 
            <div class="row d-flex justify-content-center align-self-end" id="aboutUscontent">
            
                <h3 id="aboutUstitle">ABOUT US</h3>

                <div class="col-9 align-self-center" id="aboutUsText">
                    <div class="aboutUsParagraph"> 
                        <p><span style="color:#2F437A">Since impoverished Filipino children are faced with the challenge of having 
                            to study in their own homes due to the Pandemic, Aldrin Licayan, a Filipino nurse in Ireland, started a 
                            GoFundme page to collect the means needed to provide tablets for students who are unable to afford them. 
                            Motivated to help more Filipino youth, the organization has been created to make this unique learning experience 
                            more manageable for the less fortunate children. Working alongside him are fellow Filipinos from different countries 
                            who share the same goal. Holding benefit concerts, creating campaign videos and a continuous discussion of the situation, 
                            the organization raises awareness and funds to help Filipino youth get support in the distance learning scheme both for online learning 
                            and modular learning.</span></p> 
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- MISSION AND VISION TEXT -->
    <section class="ourMissionOurVisionSection" >
        <div class="container ourMissionourVisionContainer">
            <div class="row">

                <!-- FIRST COLUMN -->
                <div class="col-sm-6 firstColumn">
                    <div class="row">
                        <div class="col">
                            <h3 id="missionTitle">OUR MISSION</h3>
                                <div class="missionParagraph">
                                    <p><span style="color:#2F437A">
                                    We exist to raise awareness of the imbalance of opportunities among the Filipino youth and find a way to bridge that disparity by holding fundraising activities to provide them gadgets to aid in their online studies.
                                    </span></p>
                                </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="container groupPhoto">
                                <img src="@/assets/about-us/groupPhoto.png" class="img-fluid" alt="Beneficiaries group photo">
                            </div>
                        </div>
                    </div>
                </div>

                <!-- SECOND COLUMN -->
                <div class="col-sm-6">
                  <div class="row">
                    <div class="col">
                        <div class="container tabletKid">
                            <img src="@/assets/about-us/computerKid2.png" class="img-fluid" alt="Kid using a tablet"> 
                        </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                        <h3 id="visionTitle">OUR VISION</h3>
                        <div class="visionParagraph">
                            <p><span style="color:#2F437A">We envision all Filipino youth to have an equal opportunity in accessing online education.
                            </span></p>
                        </div>
                    </div>
                  </div>
                </div>

            </div>
        </div> 
    </section>

     <!-- OUR TEAM TEXT -->
     <section class="ourTeamMain">
        <div class="container-fluid">
        <div class="row d-flex justify-content-center align-items-center" id="ourTeamcontent">
            
            <h3 id="ourTeamtitle">OUR TEAM</h3>

            <div class="col-sm-7" id="ourTeamText">
                <div class="ourTeamParagraph">
                <p><span style="color:#2F437A">Our team is made up of millennial and Gen Z 
                    Filipinos located all over the world but passionate about helping the Filipino youth.
                      All of the team members are 100% volunteers, who dedicate their time to the organization.
                        Whether it is applying strategic concepts in their real jobs, content creators, or live streaming
                         skills, each one of our members are key to the success of Tech For Filipino Youth.</span></p>
                </div>
            </div>
        </div>
        </div>
    </section>

    <!-- OUR TEAM GALLERY -->
    <section class="ourTeamGallery">
        <div class="container-fluid" id="teamGallery">
            <div class="teamShots">
                <img src="@/assets/about-us/teamphotos/1Cristian.png" alt="Cristian">
                <img src="@/assets/about-us/teamphotos/2Kata.png" alt="Kata">
                <img src="@/assets/about-us/teamphotos/3Khamae.png" alt="Khamae">
                <img src="@/assets/about-us/teamphotos/4Erika.png" alt="Erika">
                <img src="@/assets/about-us/teamphotos/5Chessa.png" alt="Chessa">
                <img src="@/assets/about-us/teamphotos/6Alfritz.png" alt="Alfritz">
                <img src="@/assets/about-us/teamphotos/7Thea.png" alt="Thea">
                <img src="@/assets/about-us/teamphotos/8MadamChu.png" alt="MadamChu">
                <img src="@/assets/about-us/teamphotos/9JFM.png" alt="JFM">
                <img src="@/assets/about-us/teamphotos/10Nikka.png" alt="Nikka">
                <img src="@/assets/about-us/teamphotos/11Mhar.png" alt="Mhar">
                <img src="@/assets/about-us/teamphotos/12YasminMarcelo.png" alt="Yasmin">
                <img src="@/assets/about-us/teamphotos/13Aldrin.png" alt="Aldrin">
            </div>
        </div>
    </section>
</template>

<style scoped src="@/assets/css/aboutUsStyle.css"></style>